import { MDSIconButton, MDSIconButtonSize, MDSIconButtonVariant, MDSIconKind } from "@/mds";

export const AgentRowActionButton = ({
  "aria-label": ariaLabel,
  iconKind,
  isLoading,
  onClick,
}: {
  "aria-label": string;
  iconKind: MDSIconKind;
  isLoading?: boolean;
  onClick: () => void;
}) => (
  <MDSIconButton
    aria-label={ariaLabel}
    iconKind={iconKind}
    isLoading={isLoading}
    size={MDSIconButtonSize.XSmall}
    variant={MDSIconButtonVariant.Transparent}
    rounded
    onPress={onClick}
  />
);
